import { idbGet, idbPut, STORES } from './idb';

// البيانات المرجعية التي تحتاجها شاشات الفحص: تُحفظ على الجهاز عند كل نجاح،
// وتُقرأ من الجهاز حين لا يصل الطلب إلى الخادم.
const CACHEABLE_PATHS = [
  /^manufacturers$/,
  /^models$/,
  /^lookups$/,
  /^lookups\/by-type\/[^/]+$/,
  /^inspection-types$/,
  /^inspection-items\/by-section\/[^/]+$/,
  /^categories$/,
  /^categories\/by-manufacturer\/[^/]+$/,
  /^settings\/company$/,
];

const KEY_PREFIX = 'ref:';

// '/api/lookups?x=1' أو 'http://host/api/lookups' ← 'lookups'
export function normalizeApiPath(url) {
  let path = String(url || '');
  path = path.replace(/^[a-z]+:\/\/[^/]+/i, '');
  path = path.split('?')[0];
  path = path.replace(/^\/+/, '').replace(/^api\//, '');
  return path.replace(/\/+$/, '');
}

export function isCacheablePath(path) {
  return CACHEABLE_PATHS.some((pattern) => pattern.test(path));
}

export async function writeRefCache(path, data) {
  try {
    await idbPut(STORES.kv, { data, savedAt: Date.now() }, `${KEY_PREFIX}${path}`);
  } catch {
    // فشل التخزين لا يعطّل العمل مع الاتصال.
  }
}

async function readExact(path) {
  try {
    const entry = await idbGet(STORES.kv, `${KEY_PREFIX}${path}`);
    return entry ? entry.data : undefined;
  } catch {
    return undefined;
  }
}

// بعض المسارات تُشتق من قائمة كاملة محفوظة، فلا نحتاج تنزيل فئات كل شركة على حدة.
export async function readRefCache(path) {
  const exact = await readExact(path);
  if (exact !== undefined) return exact;

  const categoriesMatch = path.match(/^categories\/by-manufacturer\/([^/]+)$/);
  if (categoriesMatch) {
    const all = await readExact('categories');
    if (Array.isArray(all)) {
      return all
        .filter((row) => String(row.manufacturer_id) === String(categoriesMatch[1]))
        .map(({ id, manufacturer_id: manufacturerId, name }) => ({ id, manufacturer_id: manufacturerId, name }));
    }
  }

  const lookupMatch = path.match(/^lookups\/by-type\/([^/]+)$/);
  if (lookupMatch) {
    const all = await readExact('lookups');
    if (Array.isArray(all)) {
      const type = decodeURIComponent(lookupMatch[1]);
      return all
        .filter((row) => row.type === type)
        .sort((left, right) => Number(left.sort_order || 0) - Number(right.sort_order || 0));
    }
  }

  return undefined;
}

export async function refCacheSavedAt(path) {
  try {
    const entry = await idbGet(STORES.kv, `${KEY_PREFIX}${path}`);
    return entry?.savedAt || null;
  } catch {
    return null;
  }
}
